const isDate   = (value) => value instanceof Date;
const isNumber = (value) => typeof value === 'number' && !isNaN(value);

function getTimestamp(date) {
  if (typeof date === 'string' && date.indexOf(' ') > -1) {
    date = date.trim().replace(/ /g, 'T');
  }

  return isDate(date)
    ? date.getTime()
    : isNumber(date)
      ? date
      : new Date(date).getTime();
}

function nowBetweenDates(startDate, endDate) {
  const now   = Date.now();

  return getTimestamp(startDate) <= now && now <= getTimestamp(endDate);
}

function nowMoreByDate(date) {
  return getTimestamp(date) <= Date.now();
}

function nowLessByDate(date) {
  return Date.now() <= getTimestamp(date);
}

export {
  getTimestamp,
  nowBetweenDates,
  nowLessByDate,
  nowMoreByDate,
};